import type {
  EnvironmentProviders,
  ModuleWithProviders,
  Provider,
} from '@angular/core';

// Using the real services in prod, nothing to replace.
export const fakeProviders: readonly (Provider | EnvironmentProviders)[] = [];

// Empty so DatastoreFakeModule never enters the release bundle.
export const fakeDatastoreModules: ModuleWithProviders<object>[] = [];
